/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { GetAllGachaForMediaResponse } from '../../models/get-all-gacha-for-media-response';

export interface GachaServiceGetAllGachaForMedia$Params {
  mediaId: string;
}

export function gachaServiceGetAllGachaForMedia(http: HttpClient, rootUrl: string, params: GachaServiceGetAllGachaForMedia$Params, context?: HttpContext): Observable<StrictHttpResponse<GetAllGachaForMediaResponse>> {
  const rb = new RequestBuilder(rootUrl, gachaServiceGetAllGachaForMedia.PATH, 'get');
  if (params) {
    rb.path('mediaId', params.mediaId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<GetAllGachaForMediaResponse>;
    })
  );
}

gachaServiceGetAllGachaForMedia.PATH = '/api/v3/gateway/media/{mediaId}/gacha/all';
